import ron from "./images/proj/ronQuote.png";
import mySite from "./images/proj/mySite.png";
import restaurant from "./images/proj/restaurant.png";
import homeRental from "./images/proj/homerental.png";
import healthyMeals from "./images/proj/healthymeals.png";
import hackernews from "./images/proj/hackernews.png";
import contactform from "./images/proj/contactform.png";
import rnm from "./images/proj/rnm.png";
import pfe from "./images/proj/pfe.png";
import twh from "./images/proj/twh.png";
import twhdesign from "./images/proj/twh_design.png";
import dcdoors from "./images/proj/dcdweb.png";
import rolandogonzalez from "./images/proj/rogonzalez.png";
import manueldiaz from "./images/proj/mdiazweb.png";
import iroirowebstudio from "./images/proj/iroirowebstudio.png";
import tdbranddesign from "./images/proj/tdbranddesign.png";
import tdbcard from "./images/proj/tdbcard.png";
import iws1 from "./images/proj/iws1.png";
import iws2 from "./images/proj/iws2.png";
import dcd1 from "./images/proj/dcd1.png";
import dcd2 from "./images/proj/dcd2.png";

export const popularProducts = [
  {
    id: "22",
    type: "react",
    role: "Lead Engineer & Founder",
    tier: "0",
    img: iroirowebstudio,
    text: "Iroiro Web Studio",
    techstack: [
      "React",
      "Vite",
      "Bootstrap",
      "AOS",
      "GSAP",
      "REST API",
      "JavaScript",
      "HTML",
      "CSS",
    ],
    subtext:
      "Official studio website with GSAP animations, AOS scroll effects, and API-driven dynamic content sections. Full lifecycle from design to deployment.",
    desc: "IroiroWebStudio.com is the official website for the web development studio, built to showcase services, past work, and design philosophy. Built with React and Vite for performance, Bootstrap for responsive layout, and AOS + GSAP for coordinated scroll and load animations. REST API integration drives dynamic content sections, keeping the site maintainable and scalable without hard-coded data.",
    achievements:
      "Implemented coordinated GSAP and AOS motion to create a cohesive branded experience across the site. Integrated API-driven modules for services and portfolio content, eliminating hard-coded data and improving maintainability. Structured the codebase with reusable React components and Vite's build optimizations for production performance.",
    engNotes: [
      {
        title: "Coordinating GSAP and AOS",
        body: "Both libraries were active simultaneously, requiring careful configuration to prevent conflicting animation triggers. GSAP timelines were scoped to specific components while AOS handled scroll-based reveal, keeping motion cohesive without interference.",
      },
      {
        title: "API-driven content architecture",
        body: "Services and portfolio content are loaded via REST API rather than hard-coded, making the site editable without code changes. This architecture also positions the project for future CMS integration if content volume grows.",
      },
    ],
    slideLink: "",
    linklist: {
      "Visit Iroiro Web Studio": "https://iroirowebstudio.com/",
    },
    vid: "",
    cstyle: "y",
    colors: ["#EDF6F9", "#ECDB5B", "#B92769", "#B4DBF8", "#013D5A", "#13222A"],
    extra_imgs: [iws1, iws2],
  },
  {
    id: "21",
    type: "react",
    role: "Frontend Engineer & Designer",
    tier: "2",
    img: dcdoors,
    text: "Small Business Website",
    techstack: [
      "React",
      "JavaScript",
      "HTML",
      "CSS",
      "Bootstrap",
      "AOS",
      "REST API",
    ],
    subtext:
      "Business website for a custom cabinet door shop featuring a REST API-powered gallery, AOS animations, and SEO-optimized structure.",
    desc: "The Cabinet Door Maker website was designed to reflect the craftsmanship of a local cabinet door shop. Built with React, Bootstrap, and AOS, it delivers a responsive browsing experience with scroll animations that enhance visual depth. A REST API powers dynamic image loading, allowing the gallery and product listings to be updated without code changes. The site includes social integrations and an SEO-optimized structure to improve local search visibility.",
    achievements:
      "Implemented a REST API-powered image gallery enabling easy content updates without deployments. Configured AOS animations for visual depth while maintaining performance on lower-end devices. Applied on-page SEO and social metadata to improve local search visibility for the client.",
    engNotes: [
      {
        title: "Performance with image-heavy layouts",
        body: "Large product images posed a loading performance risk. Lazy loading was implemented across gallery components and AOS animation timing was tuned to avoid triggering before assets were ready, keeping the experience smooth on slower connections.",
      },
    ],
    slideLink: "",
    linklist: {
      "Visit DC Doors": "https://dcdoors.co/",
    },
    vid: "",
    cstyle: "y",
    colors: ["#F4F4F1", "#477874", "#3A5A57", "#3E5C4E", "#2F2F2F"],
    extra_imgs: [dcd1, dcd2],
  },
  {
    id: "20",
    type: "react",
    role: "Frontend Engineer & Designer",
    tier: "2",
    img: rolandogonzalez,
    text: "Creative Portfolio Website",
    techstack: ["React", "Vite", "Bootstrap", "JavaScript", "HTML", "CSS"],
    subtext:
      "Software developer portfolio built with React and Vite, modular component architecture with Bootstrap responsive layout.",
    desc: "A portfolio website for a software developer combining professional clarity with creative design. Built with React and Vite for fast builds and efficient development workflow. Bootstrap handles responsive layout while Styled Components provide a maintainable, component-scoped styling system. The site presents projects, experience highlights, and contact information in a clean, accessible interface.",
    achievements:
      "Built a modular, component-based architecture with React and Styled Components for scalable, reusable UI design. Leveraged Vite's build tooling to reduce development iteration time and optimize production output. Ensured accessibility and cross-device performance throughout.",
    engNotes: [
      {
        title: "Balancing performance and visual design",
        body: "Animations and transitions were refined using Vite's optimization features to prevent layout shifts and maintain smooth rendering. Component rendering was scoped to avoid unnecessary re-renders while keeping the UI visually rich.",
      },
    ],
    slideLink: "",
    linklist: {
      "Visit Rolando Gonzalez Portfolio": "https://rolandogonzalez.space/",
    },
    vid: "",
    cstyle: "y",
    colors: ["#0a0a0a", "#e0e0e0", "#00f0ff", "#F7C530", "#ff0900"],
    extra_imgs: [],
  },
  {
    id: "19",
    type: "react",
    role: "Frontend Engineer",
    tier: "1",
    img: manueldiaz,
    text: "Blog Portfolio Website",
    techstack: [
      "React",
      "Vite",
      "Strapi",
      "Bootstrap",
      "AOS",
      "REST API",
      "JavaScript",
      "HTML",
      "CSS",
    ],
    subtext:
      "Game developer portfolio with Strapi headless CMS integration: dynamic content management without code changes.",
    desc: "A portfolio website for a game developer built with React, Vite, and Strapi as a headless CMS. Project data and blog content are managed dynamically through Strapi, allowing the client to make content updates without touching code. AOS provides scroll-based animations throughout, and DOMPurify ensures safe rendering of rich text from the backend. Bootstrap handles responsive structure across devices.",
    achievements:
      "Integrated Strapi as a headless CMS to decouple content management from the frontend codebase, enabling the client to update projects and blog posts independently. Configured DOMPurify to safely render backend rich text, preventing XSS vulnerabilities. Delivered a fast, SEO-friendly build using Vite's production optimizations.",
    engNotes: [
      {
        title: "Secure CMS-to-frontend data flow",
        body: "Rich text content from Strapi is rendered on the frontend using dangerouslySetInnerHTML, which requires sanitization to prevent XSS. DOMPurify was applied at the rendering layer to strip unsafe markup before it reaches the DOM.",
      },
      {
        title: "Environment management across deployments",
        body: "API endpoints and CMS credentials were managed via Dotenv to separate development and production configurations, reducing the risk of environment-specific errors during deployment.",
      },
    ],
    slideLink: "",
    linklist: {
      "Visit Manuel Diaz Portfolio": "https://manueldiaz.dev/",
    },
    vid: "",
    cstyle: "y",
    colors: ["#221F1C", "#D2C6C8", "#246EB9", "#9A955B", "#3E3D28"],
    extra_imgs: [],
  },
  {
    id: "18",
    type: "react",
    role: "Frontend Engineer & Designer",
    tier: "2",
    img: twh,
    text: "Art Studio Website",
    techstack: [
      "React",
      "JavaScript",
      "HTML",
      "CSS",
      "Material UI",
      "Node.js",
      "Express",
      "Github",
    ],
    subtext:
      "Full rebranding and website for an art studio: React frontend, Node.js/Express contact form backend, and Google Analytics integration.",
    desc: "Teddy Was Here is an art studio website built to support a full brand relaunch. The frontend is built with React, Material UI, and CSS, featuring playful animations that reflect the studio's creative identity. A Node.js and Express backend powers the contact form with Nodemailer and CORS, enabling reliable email delivery. Content is structured via JSON for easy updates, and Google Analytics was integrated for ongoing visitor tracking.",
    achievements:
      "Delivered a full-stack solution covering frontend design, backend contact form infrastructure, domain setup, and hosting configuration. Implemented Google Analytics and on-page SEO to support the client's visibility goals. Designed and animated the UI to reflect the studio's brand identity using React and CSS.",
    engNotes: [
      {
        title: "Full-stack ownership across a client project",
        body: "This project required managing both frontend and backend delivery as a single engineer: covering UI design, animation, backend API, email integration, domain configuration, and deployment. Structuring content as JSON data kept the codebase maintainable and reduced dependency on code changes for content updates.",
      },
      {
        title: "SEO and analytics implementation",
        body: "Google Analytics was integrated via script tag and configured for event tracking. On-page SEO was applied through semantic HTML structure, meta tags, and Open Graph data to improve search indexing and social sharing previews.",
      },
    ],
    slideLink: "",
    linklist: {
      "Visit Teddy Was Here": "https://teddywashere.art/",
    },
    vid: "",
    cstyle: "y",
    colors: [
      "#000000",
      "#5E376D",
      "#6B5A72",
      "#D4BBDD",
      "#FFCC00",
      "#EDE1DA",
      "#F4F0EC",
    ],
    extra_imgs: [twhdesign, tdbranddesign, tdbcard],
  },
  {
    id: "17",
    type: "react",
    role: "Frontend Engineer",
    tier: "3",
    img: pfe,
    text: "Figma React Integration",
    techstack: ["React", "TypeScript", "CSS", "Styled Components"],
    subtext:
      "Figma mockup implemented as a responsive React + TypeScript application with Styled Components.",
    desc: "A React and TypeScript implementation of a provided Figma design mockup. Components are structured to reflect the design's natural layout groupings, keeping the relationship between design decisions and implementation clear. Styled Components handle component-scoped dynamic styles while vanilla CSS manages global layout. Application data is sourced from a local JSON file.",
    achievements:
      "Delivered a pixel-accurate, fully responsive implementation of the Figma design. Applied TypeScript throughout for type safety on component props and JSON data structures. Used modular component architecture to ensure the codebase remains maintainable as the design evolves.",
    engNotes: [
      {
        title: "Figma-to-code translation approach",
        body: "Components were structured to mirror the Figma design's natural groupings rather than rebuilding the layout from scratch. This kept the implementation aligned with design intent and made future design changes easier to trace back to specific components.",
      },
    ],
    slideLink: "",
    linklist: {
      Demo: "https://pafinfe-ediaz.netlify.app/",
      Github: "https://github.com/diazelena325/pafin_frontend",
    },
    vid: "",
    cstyle: "y",
    colors: [
      "#2e3f51",
      "#5f799c",
      "#1e54b7",
      "#276ef1",
      "#38c97c",
      "#eef4fa",
      "#ffffff",
    ],
  },
  {
    id: "16",
    type: "react",
    role: "Frontend Engineer",
    tier: "3",
    img: rnm,
    text: "Rick and Morty",
    techstack: ["Next.js", "React", "TypeScript", "CSS", "REST API"],
    subtext:
      "Next.js app fetching episode and character data from the Rick and Morty public API: interactive image feed with episode-based filtering.",
    desc: "A Next.js application built with React and TypeScript that implements an interactive character image feed using the public Rick and Morty REST API. Episodes are listed in a side navigation panel and selecting an episode updates the main view with characters from that episode. Deselecting reverts the view to the default state, managed through React component state without additional routing.",
    achievements:
      "Implemented a two-step API data pattern: fetching episode IDs first, then resolving individual character data, to efficiently drive the feed without over-fetching. Managed selection and deselection state to keep the UI predictable across interaction cycles.",
    engNotes: [
      {
        title: "API-driven state management",
        body: "Episode selection is handled through React state rather than URL routing. When an episode is selected, a new API request fetches the corresponding character data and updates the feed. On deselection, the component reverts to the initial data set, keeping navigation intuitive without adding routing complexity to a single-view app.",
      },
    ],
    slideLink: "",
    linklist: {
      Demo: "https://rickandmorty-diaz-demo.netlify.app/",
      Github: "https://github.com/diazelena325/rick_morty",
    },
    vid: "",
    cstyle: "y",
    colors: [
      "rgb(0, 0, 0)",
      "rgb(32, 55, 69)",
      "rgb(191, 222, 66)",
      "rgb(65, 180, 201)",
      "rgb(168, 205, 205)",
      "rgb(255, 255, 255)",
    ],
  },
  {
    id: "15",
    type: "react",
    role: "Full-Stack Engineer",
    tier: "1",
    img: contactform,
    text: "Full-Stack Contact Form",
    techstack: ["React", "Node.js", "Express", "Nodemailer", "REST API"],
    subtext:
      "React frontend and Node.js/Express backend with Nodemailer email delivery. Documented end-to-end in a 3-part dev.to article series.",
    desc: "A full-stack contact form implementation built to document the complete process for other developers. The React frontend handles form state, validation, and API communication. The Node.js and Express backend receives submissions, processes them, and delivers email notifications via Nodemailer,including an auto-reply to the form submitter. The project is documented in a three-part dev.to article series covering frontend setup, backend implementation, and deployment.",
    achievements:
      "Documented a complete full-stack implementation in a three-part tutorial series on dev.to, breaking down each layer of the stack into clear, reproducible steps. Built both frontend and backend independently as separate repositories to reflect real-world project structure and make the tutorial easier to follow in stages.",
    engNotes: [
      {
        title: "Auto-reply email pattern",
        body: "On successful form submission, the server triggers a second Nodemailer send to deliver a confirmation email back to the form submitter. The auto-reply is initiated inside the callback of the first send to ensure it only fires on confirmed delivery.",
      },
      {
        title: "Credential isolation via config.js",
        body: "SMTP credentials and personal details are isolated in a config.js file rather than scattered through server logic. This keeps sensitive values out of the main codebase and makes the project reusable,anyone cloning the repo only needs to fill in their own config to run it.",
      },
    ],
    slideLink: "",
    linklist: {
      "Github Frontend": "https://github.com/diazelena325/contactform",
      "Github Backend": "https://github.com/diazelena325/contactform_backend",
      "Article Series on dev.to":
        "https://dev.to/elenadiaz32505/part-1-full-stack-contact-form-getting-started-react-frontend-2023-1bh4",
    },
    vid: "",
    cstyle: "y",
    colors: ["#6d6875", "#b5838d", "#e5989b", "#ffb4a2", "#ffcdb2"],
  },
  {
    id: "13",
    type: "react",
    role: "Frontend Engineer",
    tier: "3",
    img: hackernews,
    text: "Hacker News List",
    techstack: [
      "React",
      "TypeScript",
      "REST API",
      "Styled Components",
      "Jest",
      "Material UI",
    ],
    subtext:
      "Top 500 Hacker News stories with infinite scrolling, glassmorphism UI, and Jest unit tests.",
    desc: "A React and TypeScript application that fetches and displays the top 500 stories from the Hacker News public API. Stories load in batches of 30 via a custom useInfiniteScroll hook, with a loader displayed before the initial render. Each story is presented as a glassmorphism card,cards with URLs include a hover animation and open the article in a new tab. Unit tests cover component rendering, API fetch logic, and snapshot testing.",
    achievements:
      "Built a custom useInfiniteScroll hook to handle batch loading without a third-party dependency. Implemented glassmorphism card styling with CSS backdrop-filter and Styled Components for component-scoped styles. Wrote unit tests with Jest and React Testing Library covering components, API calls, and snapshot assertions.",
    engNotes: [
      {
        title: "Custom infinite scroll hook",
        body: "Scroll position is calculated using Math.trunc() to account for sub-pixel rendering differences across browsers. Without this, a 0.5px discrepancy on smaller screens caused the next batch trigger to fire incorrectly, preventing stories from loading.",
      },
      {
        title: "Two-step API data fetching",
        body: "The Hacker News API requires separate calls:first to retrieve the list of top story IDs, then individual calls per story. Stories are fetched and rendered in batches of 30 to avoid blocking the initial render with 500 simultaneous requests.",
      },
      {
        title: "TypeScript type safety on API responses",
        body: "Setting correct types for API response data required defining a typed interface for the story shape and updating the Listings component to use it instead of the any type used during initial development.",
      },
    ],
    slideLink: "",
    linklist: {
      Demo: "https://hacker-news-ediaz.netlify.app/",
      Github: "https://github.com/diazelena325/hacker_news_list",
    },
    vid: "",
    cstyle: "y",
    colors: [
      "#02345A",
      "#008793",
      "#00bf72",
      "#ffffff2d",
      "#47474743",
      "#ffffff",
      "#cacacada",
    ],
  },
  {
    id: "9",
    type: "ux",
    role: "UX Design & Development",
    img: homeRental,
    text: "Home Rental",
    techstack: [
      "Figma",
      "React",
      "User Research",
      "Wireframing",
      "Prototyping",
    ],
    subtext:
      "End-to-end UX case study: user research, wireframes, high-fidelity Figma prototype, and React implementation.",
    desc: "A full UX design case study for a rental home search experience, covering the complete process from user research to working prototype. The design targets both mobile and desktop users, with a focus on reducing friction in the rental search process by surfacing the criteria most relevant to user decision-making.",
    achievements:
      "Led user research to identify pain points in the rental search process, synthesizing findings into design decisions. Produced wireframes, a sitemap, and a high-fidelity Figma prototype before implementing a functional React application. Maintained design consistency across mobile and desktop breakpoints throughout.",
    engNotes: [
      {
        title: "Research-driven layout decisions",
        body: "User research identified that renters were overwhelmed by too many criteria presented at equal visual weight. The layout was restructured to surface the highest-priority decision factors: price, location, and availability, with secondary details accessible but de-emphasized.",
      },
      {
        title: "Responsive consistency across breakpoints",
        body: "Maintaining consistent interaction patterns across mobile and desktop required separate layout considerations for each breakpoint rather than a single fluid approach,ensuring the search experience felt intentional on both screen sizes rather than adapted.",
      },
    ],
    slideLink: "",
    linklist: {
      Demo: "https://rental-homes.netlify.app/",
      Github: "https://github.com/diazelena325/rental_homes",
      "Figma High Fidelity Prototype":
        "https://www.figma.com/proto/ZJ6PCrveaWMOQcjnVSGLP4/High-Fidelity%3A-Rental-Homes?page-id=0%3A1&node-id=4-46&starting-point-node-id=4%3A46&mode=design&t=3MY31uGKQylbhQKM-1",
    },
    vid: "",
    cstyle: "y",
    colors: ["#373F41", "#545454", "#3C64B1", "#FFE603", "#FFFFFF"],
  },
  {
    id: "7",
    type: "react",
    role: "Frontend Engineer",
    tier: "3",
    img: ron,
    text: "Ron Swanson Quotes",
    techstack: [
      "React",
      "JavaScript",
      "HTML",
      "CSS",
      "REST API",
      "HTML2Canvas",
    ],
    subtext:
      "Quote generator using the Ron Swanson public API with client-side PNG export via HTML2Canvas.",
    desc: "A React application that fetches random Ron Swanson quotes from a public REST API and renders them as styled cards. Users can generate new quotes on demand and save any quote as a PNG image using HTML2Canvas, capturing the rendered DOM element directly in the browser without a backend dependency.",
    achievements:
      "Implemented client-side image export using HTML2Canvas to capture and download styled quote cards as PNG files, keeping the feature entirely frontend with no server requirement. Integrated the Ron Swanson Quotes API for on-demand quote fetching.",
    engNotes: [
      {
        title: "Client-side image export with HTML2Canvas",
        body: "Rather than generating images server-side, HTML2Canvas captures the rendered DOM element in the browser and converts it to a downloadable PNG. This keeps the implementation self-contained and removes any backend dependency for the save feature.",
      },
    ],
    slideLink: "",
    linklist: {
      Github: "https://github.com/diazelena325/ronswanson_qg",
    },
    vid: "",
    cstyle: "y",
    colors: ["#F7B32B", "#F70C95", "#87B5C4", "#000000", "#6F6D6E"],
  },
  {
    id: "5",
    type: "ux",
    role: "UX Design Case Study",
    img: restaurant,
    text: "Miyabi Yakitori",
    techstack: ["Figma", "User Research", "Wireframing", "Prototyping"],
    subtext:
      "UX design case study for a Japanese restaurant mobile web app: research, wireframes, and high-fidelity Figma prototype.",
    desc: "A UX design case study for a mobile web app for a restaurant in Osaka, Japan. The project covers the full design process: user research, information architecture, wireframing, and high-fidelity prototyping in Figma with a focus on creating a clear, culturally considered dining experience for both local and international guests.",
    achievements: "",
    engNotes: [],
    slideLink:
      "https://docs.google.com/presentation/d/1xaRtinrQjHtQVwAKa5GjouwM39M9avC-LUNV7qgrbeQ/edit?usp=sharing",
    linklist: {
      "Figma High Fidelity Prototype":
        "https://www.figma.com/proto/JVILJBTmJ731RimlgjAsBE/Google-Portfolio-1-Restaurant?page-id=117%3A184&type=design&node-id=117-185&viewport=710%2C423%2C0.34&t=854jeccePN7nLT9h-1&scaling=scale-down&starting-point-node-id=117%3A185&show-proto-sidebar=1&mode=design",
    },
    vid: "",
    cstyle: "y",
    colors: ["#3F4142", "#6F7676", "#7B8C94", "#D06C45", "#D5C7B6"],
  },
  {
    id: "4",
    type: "ux",
    role: "UX Design Case Study",
    img: healthyMeals,
    text: "Healthy Meals",
    techstack: ["Figma", "User Research", "Wireframing", "Prototyping"],
    subtext:
      "UX design case study for a healthy meal planning app, research-driven design focused on reducing friction in food decision-making.",
    desc: "A UX design case study for a mobile app and website helping adults discover and cook healthier meals. The project follows the full UX process: user research, persona development, information architecture, wireframing, and high-fidelity prototyping in Figma. The design prioritizes surfacing relevant meal options efficiently while maintaining accessibility across all functionality and UI layouts.",
    achievements:
      "Applied the full UX research and design process: user interviews, competitive analysis, wireframing, and iterative prototyping, to produce a high-fidelity Figma prototype. Structured the information architecture to prioritize user-relevant content at each step of the meal discovery flow. Incorporated accessibility considerations into all UI components and interaction patterns.",
    engNotes: [
      {
        title: "Information hierarchy for decision support",
        body: "Research revealed that users abandoned meal planning flows when too many options were presented without clear filtering. The design addressed this by surfacing a small set of contextually relevant options first, with progressive disclosure for users who wanted to explore further.",
      },
      {
        title: "Accessibility-first UI decisions",
        body: "Accessibility was treated as a design constraint from the start rather than a retrofit: color contrast, touch target sizing, and screen reader-compatible component structure were built into the wireframe stage before visual design began.",
      },
    ],
    slideLink:
      "https://docs.google.com/presentation/d/1u4HYntNSACVwK_LwioiCtPS4CJ1rC1QXKPmmQx0teEY/edit?usp=sharing",
    linklist: {
      "Figma High Fidelity Prototype":
        "https://www.figma.com/proto/qNi3fYOGGMbHFaQkobjDbQ/Social-Good-Project?page-id=101%3A2&node-id=101%3A3&viewport=-906%2C367%2C1.01&scaling=scale-down&starting-point-node-id=101%3A3",
    },
    vid: "",
    cstyle: "y",
    colors: ["#35495E", "#347474", "#42B883", "#FF7E67", "#D9D9D9"],
  },
  {
    id: "1",
    type: "react",
    role: "Frontend Engineer & Designer",
    tier: "3",
    img: mySite,
    text: "My Portfolio",
    techstack: [
      "React",
      "JavaScript",
      "Node.js",
      "Material UI",
      "Styled Components",
      "Figma",
      "Procreate",
    ],
    subtext:
      "Personal portfolio, responsive React single-page application with custom graphics designed in Procreate and Figma.",
    desc: "A responsive single-page portfolio website built with React, Styled Components, and Material UI. Custom graphics were designed in Procreate and Figma. The site uses reusable component architecture throughout and includes a Node.js backend for contact form handling, processing submissions and sending automated replies without relying on third-party form services.",
    achievements:
      "Designed all custom graphics in Procreate and Figma, owning the full design-to-development lifecycle. Built a Node.js contact form backend to replace a third-party service that had become unreliable, gaining full control over submission handling and automated responses. Improved component reusability across versions through React props and state patterns.",
    engNotes: [
      {
        title: "Replacing a third-party form service with a custom backend",
        body: "The original contact form relied on an external service that became unreliable and eventually stopped working. Rather than switching to another third-party dependency, a Node.js and Express backend was built to handle submissions directly, giving full control over delivery, auto-reply logic, and error handling.",
      },
    ],
    slideLink: "",
    linklist: {},
    vid: "",
    cstyle: "y",
    colors: [
      "#2F2F2F",
      "#57737A",
      "#bed2d5",
      "#bca446",
      "#FDECDF",
      "#f7b681",
      "#efd5d5",
    ],
  },
];
